export enum MensagemStatusEnum{
  SENT = 'SENT',
	DELIVERED = 'DELIVERED',
  READ = 'READ',
  FAILED = 'FAILED',
  DELETED = 'DELETED',
  POSSUE_SESSAO = 'POSSUE_SESSAO'
}
